import { useLocation } from "@remix-run/react";
import { TemplateType } from "@commons-monorepo/index";
import { ProductFilterSkin1 } from "./skins/product-filter-skin-1";
import { useGlobalStyles } from "~/styles/context/global-styles-wrapper";

type Props = {
  onClick?: () => void;
  productsQuantity: number;
};

export const ProductFilter = ({ onClick, productsQuantity }: Props) => {
  const location = useLocation();
  const { theme } = useGlobalStyles();
  const showTags = theme.template.PRODUCTS_FILTER.PROPS.SHOW_TAGS;
  const showQuantityInTitle =
    theme.template.PRODUCTS_FILTER.PROPS.SHOW_QUANTITY_IN_TITLE ||
    location.pathname.includes("servicios");

  return (
    <>
      {theme.template.PRODUCTS_FILTER.SKIN ===
        TemplateType.PRODUCTS_FILTER_SKIN_1 && (
        <ProductFilterSkin1
          showTags={showTags}
          showQuantityInTitle={showQuantityInTitle}
          onClick={onClick}
          productsQuantity={productsQuantity}
          isInServicesTab={false}
        />
      )}
    </>
  );
};
